<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-6" ref="col-6" style="min-height: 0"></div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row" v-if="section.isAffixed">
        <div :class="getClasses(['col-6', 'd-none', 'd-md-block', 'section-height'].concat(section.left.classes))">
          <affix :relative-element-selector="relativeElement(section, index)" :offset="{ top: 56, bottom: 0 }" :scroll-affix=true class="d-none d-sm-block" :enabled=true>
            <div :style="affixStyle()">
              <div class="margin-for-nav section-left section-content">
                <slot :component="section.component" side="left" :section="section">
                  <p class="small">Oops, {{ section.component }} not found..</p>
                </slot>
              </div>
            </div>
          </affix>
        </div>
        <div class="col-12 col-md-6" :id="contentId(section, index)">
          <div :class="getClasses(['row', 'd-md-none', 'section-height'].concat(section.left.classes))">
            <div class="col-12">
              <div class="margin-for-nav section-left section-content">
                <slot :component="section.component" side="left" :section="section">
                  <p class="small">Oops, {{ section.component }} not found..</p>
                </slot>
              </div>
            </div>
          </div>
          <div :class="getClasses(['row'].concat(section.right.classes))">
            <div class="col-12">
              <div class="section-content right">
                <slot :component="section.component" side="right" :section="section">
                  <p class="small">Oops, {{ section.component }} not found..</p>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="getClasses(['row'].concat(section.classes))" v-else-if="!section.isAffixed">
        <div class="col-12" :id="contentId(section, index)">
          <slot :component="section.component" side="none" :section="section">
            <p class="small">Oops, {{ section.component }} not found..</p>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'affixed-section',
  props: {
    index: {
      type: Number,
      required: true,
    },
    section: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      col6Width: 0,
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.getCol6Width()
  },
  computed: {
    ...mapGetters(['containerSize']),
  },
  methods: {
    arrayToClasses: function (array) {
      return array.reduce((map, item) => { map[item] = true; return map }, {})
    },
    getClasses: function (classes) {
      return this.arrayToClasses(classes || [])
    },
    getContainerMarginLeft: function () {
      return (this.containerSize.marginLeft + 15)
    },
    getCol6Width: function () {
      this.col6Width = (this.$refs['col-6']) ? (this.$refs['col-6'].clientWidth - 31) + 'px' : '100%'
    },
    contentId: function (section, idx) {
      return section.id + '-' + idx
    },
    relativeElement: function (section, idx) {
      return "#" + this.contentId(section, idx)
    },
    affixStyle: function () {
      const width = this.col6Width
      return {
        width,
        paddingBottom: '56px',
        marginLeft: this.getContainerMarginLeft() / 2 + 'px',
      }
    },
    handleResize: function () {
      this.getCol6Width()
    },
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style lang="scss">
.v-align-wrapper {
  position: relative;
  .v-align {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AffixedSection.vue